export default function install(Vue) {
    /**
     * 警告提示
     */
    Vue.prototype.confirm = function (options = {}) {
        options = {
            showCancelButton:options.showCancelButton,
            message: options.message || '确认当前操作？',
            title: options.title || '提示',
            thenFun: options.thenFun || '',
            catchFun: options.catchFun || '',
            buttonCon: options.buttonCon || '确定',
            // buttonCan: options.buttonCan || '取消'
        }

        this.$confirm(options.message, options.title, {
            confirmButtonText: options.buttonCon,
            cancelButtonText: options.buttonCan,
            showCancelButton:options.showCancelButton,
            type: 'warning'
        }).then(() => {
            options.thenFun && options.thenFun()
        }).catch(() => {
            options.catchFun && options.catchFun()
        })
    }
    Vue.prototype.sucMeassage = function (msg) {
        this.$message({
            message: msg,
            type: 'success'
        });
    }
}